import axios from "axios";
import { domain } from '../../domain.js'

axios.defaults.baseURL = domain;